"use client";

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { Center, Loader, Stack, Text } from '@mantine/core';
import Head from 'next/head';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Since auth is handled in layout, you can directly redirect here if needed
    router.push('/dashboard');
  }, [router]);

  return (
    <>
      <Head>
        <title>FasTrax</title>
        <link rel="icon" href="/favicon.ico" />
        <link rel="manifest" href="/manifest.json" />
      </Head>
      <Center h="100vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm">Loading...</Text>
        </Stack>
      </Center>
    </>
  );
}